import styled, { css } from 'styled-components';

import { CONTAINER_MAX, CONTENT_MAX_WIDTH } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div<{ $hasTapBar: boolean }>`
  ${flexColumn};
  min-height: 100vh;

  .lotriver-desk-top-banner {
    a img {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    ${({ $hasTapBar }) =>
      $hasTapBar &&
      css`
        padding-bottom: 80px;
      `}
  }
`;

export const MainContent = styled.main<{ $noMobileHeader?: boolean }>`
  flex: 1;
  ${flexColumn};
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  margin-inline: auto;
  padding-top: 75px;

  @media (max-width: ${CONTAINER_MAX.tabletL}) {
    padding-top: 75px;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    padding-top: ${({ $noMobileHeader }) => ($noMobileHeader ? '0' : '58px')};
  }
`;
